import { createSlice } from "@reduxjs/toolkit";

const initialState = { contacts: [], contactDetails: null };

export const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    setContactList: (state, { payload }) => {
      return {
        ...state,
        contacts: payload,
      };
    },

    setContactDetails: (state, { payload }) => {
      return {
        ...state,
        contactDetails: payload,
      };
    },

    replyContact: (state, { payload }) => {
      return {
        ...state,
        contacts: state.contacts.map((contact) =>
          contact._id === payload._id
            ? { ...contact, reply: payload.reply }
            : contact
        ),
      };
    },

    deleteContact: (state, { payload }) => {
      return {
        ...state,
        contacts: state.contacts.filter((contact) => contact._id !== payload),
      };
    },
  },
});
